import React, { useContext } from 'react';

import i18n from '../../../../i18n';
import { useTranslation } from "react-i18next";

import { VERSION } from '../../../../configurations/version.config'

import { WEB_AUTH_URL } from "../../../../configurations/paths.config"

import { Stack } from '@fluentui/react';
import { DefaultButton } from '@fluentui/react/lib/Button';
import '../../../../styles/css/UserActions.css'
import MainAppContext from '../../../../MainAppContext';
import { __enum_SystemPages, __SystemPagesPaths } from '../../../../common/Dictionaries';
import PropTypes from 'prop-types';
import { __onGoToProfileClick } from '../../../../common/SystemRedirections';
import Flag from './Flag';
import { removeAuth } from '../../../../services/Auth/auth.service';
import { Col, Row } from 'react-bootstrap';

const UserActions = (props) => {

    const {
        inputParam_Display = false,
        inputParam_PageTitle = null,
        inputParam_UserName = "User Name",
        inputParam_UserFullName = "",
        inputParam_Rol = "",
    } = props;


    const contextSite = useContext(MainAppContext);

    const { t } = useTranslation();

    const styleMenu = { root: { fontSize: '20px', marginRight: "15px", fontWeight: "bold" } }
   

    const flagEsUrl = 'ES';
    const flagEnUrl = 'EN';
    const { disabled, checked } = props;
    const stackTokens = { childrenGap: 40 };



    const onLogoutClick = async () => {
        await removeAuth();
        const url = `${WEB_AUTH_URL}`;
        window.location.href = url;
    }

    const onChangeLanguageClick = (languaje) => {
      i18n.changeLanguage(languaje)
    }

    const menuProps = {
        items: [{
            key: 'profile',
            text: t('data-lang-topnavbar-profile'),
            iconProps: { iconName: 'UserOptional',  styles: styleMenu },
            onClick: __onGoToProfileClick,
        }, {
            key: 'edituser',
            text: t('data-lang-topnavbar-logout'),
            iconProps: { iconName: 'SignOut',  styles: styleMenu },
            onClick: onLogoutClick,
        }, {
            key: 'spanish',
            text: t('data-lang-lbl-spanish'),
            iconProps: { styles: styleMenu },
            onClick: () => onChangeLanguageClick("es"),
            onRenderIcon: () => {
                return <Flag inputParam_Code={flagEsUrl} />
            }
        }, {
            key: 'english',
            text: t('data-lang-lbl-english'),
            iconProps: { styles: styleMenu },
            onClick: () => onChangeLanguageClick("en"),
            onRenderIcon: () => {
                return <Flag inputParam_Code={flagEnUrl} />
            }
        }, {
            key: 'export',
            text: t('data-lang-lbl-export'),
            iconProps: { iconName: 'CloudDownload',  styles: styleMenu },
            onClick: () => contextSite.exportFunction(inputParam_PageTitle),
        }, {
            key: 'version',
            text: t('data-lang-systemversion') + VERSION,
            iconProps: { iconName: 'Info',  styles: styleMenu },
            className: "border-top",
        }]
    };

    return (
        <>
            {
                inputParam_Display &&
                <div className='user-action-dropdown'>
                <Stack horizontal wrap tokens={stackTokens}>
                    <DefaultButton
                        iconProps={{ iconName: 'Settings' }}
                        primary
                        split
                        onClick={null}
                        menuProps={menuProps}
                        disabled={disabled}
                        checked={checked}
                        style={{border: "none", backgroundColor: "transparent"}}
                    >
                        <div style={{whiteSpace: 'nowrap', fontSize: '11px'}}>
                            <Row><Col><strong>{inputParam_UserName}</strong></Col></Row>
                            <Row><Col><span>{inputParam_UserFullName}</span></Col></Row>
                            <Row><Col><span>{inputParam_Rol}</span></Col></Row>
                        </div>
                    </DefaultButton>
                </Stack>
            </div>
            }
        </>
    )
}

///Proptypes
UserActions.propTypes = {
    inputParam_Display: PropTypes.bool.isRequired,
    inputParam_PageTitle: PropTypes.string.isRequired,
    inputParam_UserName : PropTypes.string.isRequired,
};

export default UserActions